module.exports = __webpack_public_path__ + "img/edit.fa0748ad.png";